module.exports = __webpack_public_path__ + "static/media/Click2.f052a0c1.mp3";